import { useRef, useState } from "react";
import {
    Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip,
    Grid2 as Grid,
    IconButton,
    InputAdornment,
    MenuItem,
    Select,
    Slider,
    TextField,
} from '@mui/material';
import { ArrowLeft, Backspace, Check, FilterAlt, Search } from '@mui/icons-material';
import { propComparator, } from "../utils/ui_utils";

import { useEvent } from "../context/eventContext";
import { globalstyles } from "../lib/definitions";
import { CategoryButton, CategoryHeader, CategoryLabel, CategoryRow } from "../definitions/category";
import { DialogMultiSelector } from "../components/AdvanceSelector";
import { PropertyButton, PropertyHeader, PropertyRow } from "../definitions/property";
import { get_Cowman_list } from "../FirebaseUtils/dbCowman";
import { get_Property_list } from "../FirebaseUtils/dbProperty";
import { CowmanButton, CowmanHeader, CowmanRow } from "../definitions/cowman";
import { get_Category_list } from "../FirebaseUtils/dbCategory";




export const FilterSearchBar = ({ setSearchText, updateFilterApplied, filterApplied, doSearch, sidebar_size }) => {
    const { selEvent } = useEvent()
    const searchRef = useRef()
    const [search_text, setIntSearchText] = useState('')
    const get_cowmanlist = async () => {
        const res = await get_Cowman_list(selEvent.id)
        console.log("RES", res)
        if (res.addedList) {
            return res.addedList
        }
        return res.sort(propComparator('cdaua_cowman'))
    }
    const get_propertylist = async () => {
        const res = await get_Property_list(selEvent.id)
        console.log("RES", res)
        if (res.addedList) {
            return res.addedList
        }
        return res.sort(propComparator('cdaua'))
    }

    const get_categorylist = async () => {
        const res = await get_Category_list(selEvent.id)
        console.log("RES", res)
        if (res.addedList) {
            return res.addedList
        }
        return res.sort(propComparator('order'))
    }
    const _doSearch = (txt) => {
        doSearch(search_text)
    }



    const clearSearch = () => {
        doSearch('');
        setIntSearchText('');
        searchRef.current.value = ''
    }
    return (

        <Grid size={sidebar_size} sx={globalstyles.action_row} spacing={1} container flexDirection={"column"}>
            <Grid size={12}>
                <TextField
                    id="search_text"
                    type="search_text"
                    name="search_text"
                    size="small"
                    placeholder="cerca (cat, nome, matr.)"
                    autoComplete="search_text"
                    autoFocus
                    fullWidth
                    ref={searchRef}
                    value={search_text}
                    variant="outlined"
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Button onClick={() => _doSearch()} size="small" variant="outlined" startIcon={<Search />}>
                                        Cerca
                                    </Button>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton size="small" onClick={() => clearSearch()}><Backspace /></IconButton>
                                </InputAdornment>
                            ),
                        },
                    }}
                    onChange={(ev) => setIntSearchText(ev.target.value)}
                />

            </Grid>

            <Grid justifyContent={"center"} sx={{ borderBottom: '1px solid black' }}>
                <Grid>
                    <FilterAlt />
                    Filtri
                </Grid>
            </Grid>
            <Grid container columnSpacing={1}>
                <Grid justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
                    Proprietà
                </Grid>
                <Grid>
                    <DialogMultiSelector
                        sourceFn={get_propertylist}
                        elem_list={filterApplied.property_list}
                        searchparam_list={['cdaua', 'name']}
                        changeFn={(val) => updateFilterApplied('property_list', val)}
                        label="Proprietà"
                        btnLabel={"imposta filtri"}
                        valueOnButton
                        idParam={'id'}
                        renderButton={(prop) => <PropertyButton {...prop} />}
                        renderRow={(prop) => <PropertyRow {...prop} />}
                        renderHeader={(prop) => <PropertyHeader {...prop} />}
                    />
                </Grid>
                <Grid>
                    <Button size="small" style={{ minWidth: '20px' }} onClick={() => updateFilterApplied('property_list', [])}><Backspace sx={{ fontSize: "1.2em" }} /></Button>
                </Grid>
            </Grid>
            {filterApplied.property_list.map((p, k) => (
                <PropertyRow element={p} />
            ))}
            <Grid container columnSpacing={1}>
                <Grid justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
                    Allevatore
                </Grid>
                <Grid>
                    <DialogMultiSelector
                        sourceFn={get_cowmanlist}
                        elem_list={filterApplied.cowman_list}
                        searchparam_list={['cdaua_cowman', 'name']}
                        changeFn={(val) => updateFilterApplied('cowman_list', val)}
                        label="Proprietà"
                        btnLabel={"imposta filtri"}
                        valueOnButton
                        idParam={'id'}
                        renderButton={(prop) => <CowmanButton {...prop} />}
                        renderRow={(prop) => <CowmanRow {...prop} />}
                        renderHeader={(prop) => <CowmanHeader {...prop} />}
                    />
                </Grid>
                <Grid>
                    <Button size="small" style={{ minWidth: '20px' }} onClick={() => updateFilterApplied('cowman_list', [])}><Backspace sx={{ fontSize: "1.2em" }} /></Button>
                </Grid>
            </Grid>
            {filterApplied.cowman_list.map((p, k) => (
                <CowmanRow element={p} />
            ))}
            <Grid container columnSpacing={1}>
                <Grid justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
                    Presenza
                </Grid>
                <Grid>
                    <ButtonGroup size="small">
                        <Button color="success" variant={filterApplied.show_presence.includes(true) ? 'contained' : 'outlined'} onClick={() => updateFilterApplied('show_presence', true, 'list')} startIcon={filterApplied.show_presence.includes(true) && <Check style={{ fontSize: '0.8em' }} />}>Presenti</Button>
                        <Button color="error" variant={filterApplied.show_presence.includes(false) ? 'contained' : 'outlined'} onClick={() => updateFilterApplied('show_presence', false, 'list')} startIcon={filterApplied.show_presence.includes(false) && <Check style={{ fontSize: '0.8em' }} />}>Non presenti</Button>
                        <Button color="warning" variant={filterApplied.show_presence.includes(undefined) ? 'contained' : 'outlined'} onClick={() => updateFilterApplied('show_presence', undefined, 'list')} startIcon={filterApplied.show_presence.includes(undefined) && <Check style={{ fontSize: '0.8em' }} />}>Non compilati</Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
            <Grid container columnSpacing={1}>
                <Grid justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
                    Tipologia
                </Grid>
                <Grid>
                    <ButtonGroup size="small">
                        <Button variant={filterApplied.show_type === undefined ? 'contained' : 'outlined'} onClick={() => updateFilterApplied('show_type')}>Visualizza tutti</Button>
                        <Button variant={filterApplied.show_type === 'black' ? 'contained' : 'outlined'} onClick={() => updateFilterApplied('show_type', 'black')}>Black</Button>
                        <Button variant={filterApplied.show_type === 'red' ? 'contained' : 'outlined'} onClick={() => updateFilterApplied('show_type', 'red')}>Red</Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
            {selEvent.custom_cow_filter_param_list && selEvent.custom_cow_filter_param_list.length > 0 &&
                selEvent.custom_cow_filter_param_list.map((cf, k) => (
                    <Grid container columnSpacing={1} key={k} >
                        <Grid justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
                            {cf.param_name}
                        </Grid>
                        <Grid>
                            <ButtonGroup size="small">
                                <Button variant={filterApplied.show_custom === undefined ? 'contained' : 'outlined'} onClick={() => updateFilterApplied('show_custom')}>Visualizza tutti</Button>
                                <Button variant={filterApplied.show_custom === cf.param_name ? 'contained' : 'outlined'} onClick={() => updateFilterApplied('show_custom', cf.param_name)}>{cf.param_name}</Button>
                            </ButtonGroup>
                        </Grid>
                    </Grid>

                ))}
            <Grid container columnSpacing={1}>
                <Grid justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
                    Categoria
                </Grid>
                <Grid>
                    <DialogMultiSelector
                        sourceFn={get_categorylist}
                        elem_list={filterApplied.category_list}
                        searchparam_list={['name']}
                        changeFn={(val) => updateFilterApplied('category_list', val)}
                        label="Categoria"
                        btnLabel={"imposta filtri"}
                        valueOnButton
                        idParam={'id'}
                        renderButton={(prop) => <CategoryButton {...prop} />}
                        renderRow={(prop) => <CategoryRow {...prop} />}
                        renderHeader={(prop) => <CategoryHeader {...prop} />}
                    />
                </Grid>
                <Grid>
                    <IconButton size="small" color="primary" onClick={() => updateFilterApplied('category_list', [])}><Backspace sx={{ fontSize: "1em" }} /></IconButton>
                </Grid>
            </Grid>
            {filterApplied.category_list.map((p, k) => (
                <CategoryRow element={p} />
            ))}
            <Grid container columnSpacing={1}>
                <Grid justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
                    età
                </Grid>
                <Grid size="grow">
                    <Slider
                        getAriaLabel={() => 'età'}
                        value={[1, 100]}
                        size="small"
                        disabled
                        onChange={(e, v) => updateFilterApplied('age', v)}
                        valueLabelDisplay="auto"
                    //getAriaValueText={valuetext}
                    />
                </Grid>
            </Grid>
            <Grid container columnSpacing={1} justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
                <Grid justifyContent={"center"} alignContent={"center"} alignItems={"center"}>
                    parti
                </Grid>
                <Grid size="grow">
                    <Slider
                        getAriaLabel={() => 'parti'}
                        value={filterApplied.birth}
                        size="small"
                        max={20}
                        min={0}
                        onChange={(e, v) => updateFilterApplied('birth', v)}
                        valueLabelDisplay="auto"
                    />
                </Grid>
                <Grid size="auto">
                    {filterApplied.birth[0]}-{filterApplied.birth[1]}
                </Grid>
            </Grid>

        </Grid>
    )
}